import config from '../config';
var ApmTypeService = /*@__PURE__*/ (function () {
    function ApmTypeService() {
    }
    ApmTypeService.get = function () {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/apmtype/find",
                success: function (res) {
                    resolve(res);
                },
                error: function (error) {
                    reject();
                }
            });
        });
    };
    ApmTypeService.getAvailable = function (rmsid) {
        return new Promise(function (resolve, reject) {
            jQuery.ajax({
                url: config.appointman.api.BASE_URI + "/apmtype/avail/" + rmsid,
                success: function (res) {
                    resolve(res);
                },
                error: function (error) {
                    reject();
                }
            });
        });
    };
    return ApmTypeService;
}());
export default ApmTypeService;



//////////////////
// WEBPACK FOOTER
// ./app/bundles/appointman/app/ts/service/ApmType.ts
// module id = null
// module chunks = 